import { ProductServerData } from '../models/fna';

export function generateProductDescription(
  products: ProductServerData[],
  riskLevel: string,
) {
  return products
    .filter((p) => p.RiskLevel === riskLevel)
    .map((p) => `<b>${p.Title}</b>${p.Description}`)
    .join('<p></p>');
}
